import { defineAsyncComponent } from 'vue'

export const DimensionComponent = defineAsyncComponent(() => import('./dimensions.vue'))
export const MetricComponent = defineAsyncComponent(() => import('./metrics.vue'))
export const FilterComponent = defineAsyncComponent(() => import('./filters.vue'))
export const AdditionalOptionsComponent = defineAsyncComponent(() => import('./additional-options.vue'))
